import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubscribe = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            await axios.post(`${API}/newsletter?email=${encodeURIComponent(email)}`);
            toast.success('Welcome to the Chill Squad!');
            setEmail('');
        } catch (error) {
            toast.error('Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <footer className="bg-black border-t border-border" data-testid="footer">
            <div className="border-b border-border py-16 md:py-24">
                <div className="max-w-[1400px] mx-auto px-4 md:px-8 text-center">
                    <span className="text-xs tracking-[0.2em] uppercase text-lime mb-4 block">STAY IN THE LOOP</span>
                    <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl mb-4">JOIN THE<br />CHILL SQUAD</h2>
                    <p className="text-muted-foreground text-sm mb-8 max-w-md mx-auto">
                        Get early access to drops, exclusive offers and style guides.<br />No spam. Just vibes.
                    </p>
                    <form onSubmit={handleSubscribe} className="flex max-w-md mx-auto" data-testid="newsletter-form">
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                            placeholder="Your email address"
                            className="flex-1 bg-card border border-border px-4 py-4 text-sm font-body placeholder:text-muted-foreground focus:outline-none focus:border-lime"
                            data-testid="newsletter-input" />
                        <button type="submit" disabled={loading}
                            className="bg-lime text-black px-6 py-4 text-xs font-bold tracking-[0.14em] uppercase hover:bg-lime/90 transition-colors disabled:opacity-50"
                            data-testid="newsletter-submit">
                            {loading ? '...' : 'SUBSCRIBE'}
                        </button>
                    </form>
                </div>
            </div>
            <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 md:py-16">
                <div className="flex flex-col md:flex-row gap-12 md:gap-8">
                    <div className="md:w-1/3">
                        <Link to="/" className="font-heading text-4xl mb-4 block">
                            <span className="text-lime">YES</span>suhchill
                        </Link>
                        <p className="text-muted-foreground text-sm leading-relaxed mb-6">
                            Streetwear for the chill ones.<br />Dress different. Be different.
                        </p>
                        <div className="flex gap-3">
                            <a href="https://instagram.com/yessuhchill" target="_blank" rel="noopener noreferrer" className="border border-border px-4 py-2 text-[10px] font-medium tracking-[0.1em] uppercase text-muted-foreground hover:border-lime hover:text-lime transition-colors">INSTAGRAM</a>
                            <a href="https://youtube.com/@yessuhchill" target="_blank" rel="noopener noreferrer" className="border border-border px-4 py-2 text-[10px] font-medium tracking-[0.1em] uppercase text-muted-foreground hover:border-lime hover:text-lime transition-colors">YOUTUBE</a>
                            <a href="https://pinterest.com/yessuhchill" target="_blank" rel="noopener noreferrer" className="border border-border px-4 py-2 text-[10px] font-medium tracking-[0.1em] uppercase text-muted-foreground hover:border-lime hover:text-lime transition-colors">PINTEREST</a>
                        </div>
                    </div>
                    <div className="md:w-2/3 grid grid-cols-2 md:grid-cols-4 gap-8">
                        <div>
                            <h4 className="font-heading text-sm tracking-[0.15em] uppercase mb-4">QUICK LINKS</h4>
                            <ul className="space-y-3">
                                <li><Link to="/products" className="text-sm text-muted-foreground hover:text-lime transition-colors">New Arrivals</Link></li>
                                <li><Link to="/products" className="text-sm text-muted-foreground hover:text-lime transition-colors">Best Sellers</Link></li>
                                <li><Link to="/products" className="text-sm text-muted-foreground hover:text-lime transition-colors">Sale</Link></li>
                                <li><Link to="/blog" className="text-sm text-muted-foreground hover:text-lime transition-colors">Lookbook</Link></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="font-heading text-sm tracking-[0.15em] uppercase mb-4">HELP</h4>
                            <ul className="space-y-3">
                                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-lime transition-colors">Track Order</Link></li>
                                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-lime transition-colors">Returns</Link></li>
                                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-lime transition-colors">Size Guide</Link></li>
                                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-lime transition-colors">FAQs</Link></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="font-heading text-sm tracking-[0.15em] uppercase mb-4">COMPANY</h4>
                            <ul className="space-y-3">
                                <li><Link to="/about" className="text-sm text-muted-foreground hover:text-lime transition-colors">About Us</Link></li>
                                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-lime transition-colors">Careers</Link></li>
                                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-lime transition-colors">Press</Link></li>
                                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-lime transition-colors">Contact</Link></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="font-heading text-sm tracking-[0.15em] uppercase mb-4">LEGAL</h4>
                            <ul className="space-y-3">
                                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-lime transition-colors">Privacy Policy</Link></li>
                                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-lime transition-colors">Terms of Use</Link></li>
                                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-lime transition-colors">Shipping Policy</Link></li>
                                <li><Link to="/contact" className="text-sm text-muted-foreground hover:text-lime transition-colors">Refund Policy</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="border-t border-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-xs text-muted-foreground">© 2025 YESSuhchill. All rights reserved.</p>
                    <p className="text-xs text-muted-foreground">Made for the chill ones.</p>
                </div>
            </div>
        </footer>
    );
};
